<template>
  <el-dialog title="仪表详情" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">

    <div style="max-height: 700px;overflow-y: auto;">
      <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
        <el-descriptions-item label="仪表编号">
          {{form.number}}
        </el-descriptions-item>
        <el-descriptions-item label="所在房产">
          {{form.house_name}}
        </el-descriptions-item>
        <el-descriptions-item label="仪表名称">
          {{form.name}}
        </el-descriptions-item>
        <el-descriptions-item label="上级仪表">
          {{form.p_name}}
        </el-descriptions-item>
        <el-descriptions-item label="倍率">
          {{form.magnification}}
        </el-descriptions-item>
        <el-descriptions-item label="仪表户号">
          <el-input size="mini" class="form-input" v-model="form.house_number" autocomplete="off" disabled></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="初始读数">
          {{form.start_number}}
        </el-descriptions-item>
        <el-descriptions-item label="仪表表号">
          <el-input size="mini" class="form-input" v-model="form.meter_number" autocomplete="off" disabled></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="回程">
          {{form.return_trip}}
        </el-descriptions-item>
        <el-descriptions-item label="仪表类型">
          <div style="display: flex;">
            <el-select size="mini" style="width: 100%" v-model="form.meter_type" filterable placeholder="仪表类型" disabled class="kuan">
              <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span style="color: red;margin-top: 5px;">*</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="安装日期">
          {{form.install_time}}
        </el-descriptions-item>
        <el-descriptions-item label="收费标准">
          <div style="display: flex;">
            <el-select size="mini" disabled style="width: 100%" v-model="form.charging_standard" filterable placeholder="收费标准" class="kuan">
              <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span style="color: red;margin-top: 5px;">*</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="上次抄表时间">
          {{form.reading_time}}
        </el-descriptions-item>
        <el-descriptions-item label="仪表排序">
          {{form.sort}}
        </el-descriptions-item>
        <el-descriptions-item label="位置">
          {{form.position}}
        </el-descriptions-item>
        <el-descriptions-item label="仪表状态">
          <el-radio disabled v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :key="item.val" v-model="form.status" :label="item.val">{{ item.name }}</el-radio>
        </el-descriptions-item>
        <!--          <el-descriptions-item label="规格">-->
        <!--            <el-input size="mini" class="form-input" v-model="form.specifications" autocomplete="off"></el-input>-->
        <!--          </el-descriptions-item>-->
        <el-descriptions-item label="仪表性质">
          <el-radio disabled v-for="item in meter_nature_list"
                    :key="item.val" v-model="form.meter_nature" :label="item.val">{{ item.name }}</el-radio>
        </el-descriptions-item>
        <el-descriptions-item label="是否虚表">
          <el-radio v-for="item in [{name:'实表',val:1},{name:'虚表',val:2}]" :key="item.val" v-model="form.meter_virtually" :label="item.val">{{ item.name }}</el-radio>
        </el-descriptions-item>
        <!-- 不是分摊表 -->
        <el-descriptions-item label="能耗类型">
          <el-radio disabled v-for="(item,index) in energy_list" :key="index" v-model="form.energy" :label="item.val">{{ item.name }}</el-radio>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          <el-input disabled type="textarea" placeholder="请输入内容" v-model="form.remarks" maxlength="100" show-word-limit></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="附件">
          <el-link type="primary" v-if="form.files" @click="$refs.ViewFileListRef.show(form.files)">查看下载</el-link>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">关闭</el-button>
    </div>
    <ViewFileList ref="ViewFileListRef" />
  </el-dialog>
</template>

<script>
import UploadFilesSysc from "../../../../App/Card/components/UploadFilesSysc";
import ViewFileList from "../../../../Common/ViewFileList";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterInfo",
  components: {ViewFileList, UploadFilesSysc},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      dialogVisible: false,
      form: {
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
      },
      meter_type_list:[],
      house_charge_list:[],
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      host_url:""
    }
  },
  methods:{
    show(data){
      this.getMeterTypeList();
      this.getHouseChargeList();
      this.form = ERP.reJson(data);
      this.dialogVisible = true
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_id,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.form.project_id&&(where.pindex_id=this.form.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      if(where.pindex_id){
        MeterHttp.get("HouseCharge/getList",{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        },ret=>{
          if(ret.code){
            that.house_charge_list=ret.data.list;
          }
        })
      }

    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterInfo.vue